<template>
  <div 
    id="data-list-list-view" 
    class="data-list-container relative"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
  >
    <!-- New: Drag and Drop Overlay -->
    <div v-if="isDragging" class="drag-overlay">
      <div class="drag-content">
        <i class="feather icon-upload-cloud"></i>
        <h2 class="drag-text">Drop Resumes to Import</h2>
      </div>
    </div>
    <ResumeUploadProgress 
        v-if="activeResumeBatchId" 
        :status="resumeBatchStatus"
        @dismiss="clearBatch"
    />
    <div class="mb-4 md:mb-8">
      <div class="px-4 py-3 flex items-center relative overflow-hidden users-container">
        <div v-if="isRequestLoading">
          <vs-avatar v-for="i in 6" :key="i" size="40px" class="animate-pulse" />
        </div>
        <h4 class="mr-2 py-4 px-2 text-warning font-bold" v-if="activeResumeBatchId">
           Processing Resumes...
        </h4>
        <h4 class="mr-2 py-4 px-2 text-success font-bold" v-else-if="uploadFinished">
           Done!
        </h4>

        <h4 class="mr-2 py-4 px-2" v-else-if="!isRequestLoading && reviewUserRequest.length === 0">
          {{ $t('orgDashboard.talentPool.noPendingRequest') }}
        </h4>
        <div class="absolute right-0 mr-4 md:flex cursor-pointer"
          v-if="!isRequestLoading && reviewUserRequest.length === 0">
          <div class="flex items-center">
            <!-- <h5 class="mx-1">{{ $t('orgDashboard.talentPool.importFrom') }} </h5> -->
            <!-- <vs-tooltip :text="$t('orgDashboard.talentPool.uploadExcel')">
              <label @click="handleUserUpload">
                <i class="vs-icon notranslate icon-scale cursor-pointer mx-2 feather icon-upload 24px"
                style="width: 24px; height: 24px; font-size: 24px; color: rgb(242, 194, 68);"></i>
              </label>
              <input id="uploadUserFile" type="file" accept=".xls,.xlsx" class="hidden" @change="handleUserUpload">
            </vs-tooltip> -->
            <h5 class="mx-1">Import Resumes </h5>
            <vs-tooltip text="Import Resumes">
              <label @click="showResumeUploadModal = true">
                <i class="vs-icon notranslate icon-scale cursor-pointer mx-2 feather icon-file-text 24px"
                style="width: 24px; height: 24px; font-size: 24px; color: rgb(76, 175, 80);"></i>
              </label>
            </vs-tooltip>
            <!-- <div class="flex"  @click="$router.push({ name: 'org-integrations' })">
                <h5>{{ $t('orgDashboard.talentPool.orHRIS') }}</h5>
                <img class="integrations-image" src="@/assets/images/icons/app-marketplace/integrations/paylocity.svg" />
                <img class="integrations-image" src="@/assets/images/icons/app-marketplace/integrations/hibob.svg" />
                <img class="integrations-image" src="@/assets/images/icons/app-marketplace/integrations/personio.svg" />
                <img class="integrations-image ml-1" src="@/assets/images/icons/app-marketplace/arrow-ios-forward.svg"
                  alt="" />
            </div> -->
          </div>
        </div>

        <h4 class="mr-2" v-if="!activeResumeBatchId && !isRequestLoading && reviewUserRequest.length > 0">
          {{ $t('orgDashboard.talentPool.pendingRequest') }}
        </h4>

        <div class="flex items-center" v-if="reviewUserRequest.length > 0">
          <div v-for="(user, index) in reviewUserRequest.slice(0, 9)" :key="index">
            <vx-tooltip v-if="user.data && user.data.firstName" class="capitalize"
              :text="`${user.data.firstName} ${user.data.lastName}`">
              <vs-avatar size="40px" class="m-1 w-100 z-10" v-if="user && user.data && user.data.profilePictureUrl"
                :src="`${constants.s3Bucket}/editor/profile-pictures/${user.data.profilePictureUrl}`" @click="
                  $router.push({
                    name: 'org-joining-users-request',
                    query: { userId: user._id },
                  })
                  " />

              <vs-avatar v-else size="40px" class="m-1" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                user.data.firstName || 'boringAvatar',
                user.data.lastName || 'boringAvatar'
              )}`" @click="
                  $router.push({
                    name: 'org-joining-users-request',
                    query: { userId: user._id },
                  })
                  " />
            </vx-tooltip>
          </div>

          <vs-dropdown vs-trigger-click :color="orgColor">
            <vs-avatar v-if="reviewUserRequest.length > 9" size="40px" class="m-1 w-100 z-10"
              :text="`+${reviewUserRequest.length - 9}`" />

            <vs-dropdown-menu>
              <vs-input class="m-2" id="vs--input" :color="`${orgColor}`" icon-no-border icon="search" icon-size="large"
                :placeholder="$t('orgDashboard.talentPool.searchUser')" v-model="searchValue" v-on:input="searchUser()" style="width: auto" />
              <vs-dropdown-item class="mt-0" v-for="(user, index) in searchedUserArray" :key="index" @click="
                $router.push({
                  name: 'org-joining-users-request',
                  query: { userId: user._id },
                })
                ">
                <vs-avatar v-if="user && user.data && user.data.profilePictureUrl" size="40px" class="-m-1 mr-2" @click="
                  $router.push({
                    name: 'org-joining-users-request',
                    query: { userId: user._id },
                  })
                  " :src="constants.s3Bucket +
                    '/editor/profile-pictures/' +
                    user.data.profilePictureUrl
                    " />
                <vs-avatar v-else-if="user && user.data && !user.data.profilePictureUrl" size="40px" @click="
                  $router.push({
                    name: 'org-joining-users-request',
                    query: { userId: user._id },
                  })
                  " class="-m-1 mr-2" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                    user.data.firstName,
                    user.data.lastName
                  )}`" />
                <p class="text-lg">
                  {{ user && user.data ? user.data.firstName : "" }}
                  {{ user && user.data ? user.data.lastName : "" }}
                </p>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <div class="absolute right-0 mr-4" v-if="reviewUserRequest.length > 0" @click="
          $router.push({
            name: 'org-joining-users-request',
          })
          ">
          <img class="arrow next" src="@/assets/images/icons/next-arrow.svg" alt="" />
        </div>
      </div>
    </div>

    <vs-table class="py-6 px-2" :search="true" :max-items="itemsPerPage" :pagination="employeesData && employeesData.length > 0" :data="employeesData"
      ref="table">
      <template slot="header">
        <div class="pb-4 flex items-center gap-5">
          <h6 class="text-2xl font-semibold text-black capitalize">
            {{ $t('orgDashboard.talentPool.allUsers') }}
          </h6>
          
          <!-- UPDATED: Wrapped in Tooltip "Add Members" -->
          <vs-tooltip text="Add Members">
            <div class="mt-2 cursor-pointer" @click="isEmpAddRequest = true">
                <vs-avatar 
                  class="-m-2 z-10 relative font-bold" 
                  size="40px" 
                  color="#10b981" 
                  text-color="white" 
                  icon-pack="feather" 
                  icon="icon-plus" 
                />
            </div>
          </vs-tooltip>
        </div>
      </template>

      <template slot="thead">
        <vs-th sort-key="name">{{ $t('orgDashboard.talentPool.name') }}</vs-th>
        <vs-th sort-key="email">{{ $t('orgDashboard.talentPool.email') }}</vs-th>
        <vs-th sort-key="accessLevel">{{ $t('orgDashboard.talentPool.maxRole') }}</vs-th>
        <vs-th sort-key="relationships">{{ $t('orgDashboard.talentPool.relationships') }}</vs-th>
        <vs-th sort-key="" style="text-align: center;">{{ $t('orgDashboard.talentPool.action') }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <!-- FIX: Changed :key from 'indextr' to 'tr._id' for robust rendering during search -->
          <vs-tr :data="tr" :key="tr._id" v-for="(tr, indextr) in data">
            
            <!-- Cell 1: NAME -->
            <vs-td class="flex items-center">
              <vs-avatar v-if="tr.userData.profilePictureUrl" size="35px" class="-m-1 mr-2" :src="constants.s3Bucket +
                '/editor/profile-pictures/' +
                tr.userData.profilePictureUrl
                " />
              <vs-avatar v-else size="35px" class="-m-1 mr-2" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                tr.userData.firstName || 'boringAvatar',
                tr.userData.lastName || 'boringAvatar'
              )}`" />
              <p class="product-name font-medium truncate">
                {{ tr.userData.firstName }} {{ tr.userData.lastName }}
              </p>
            </vs-td>

            <!-- Cell 2: EMAIL -->
            <vs-td>
              <p class="product-category">{{ tr.userData.email }}</p>
            </vs-td>
            
            <!-- Cell 3: MAX ROLE -->
            <vs-td>
                <!-- FIX: Added @input listener as a backup to ensure reactivity flows correctly -->
                <vs-select
                class="w-full"
                v-model="tr.accessLevel"
                v-validate="'required'"
                name="accessLevel"
                @change="(val) => updateRoleAccess(val, tr._id)"
                >
                    <vs-select-item v-for="(role) of roles" :key="role.key" :text="role.label" :value="role.key" />
                </vs-select>
            </vs-td>

            <!-- Cell 4: RELATIONSHIPS -->
            <vs-td>
              <span v-if="
                tr.employeeRelationshipsData &&
                tr.employeeRelationshipsData.length > 0
              ">
                <div v-for="(user, index) in getValidRelationships(tr.employeeRelationshipsData)" :key="index">
                  <vx-tooltip 
                    v-if="user.userData && user.userData.firstName" 
                    class="capitalize" 
                    :text="`${user.userData.firstName} is ${getRelationName(user.relationship)} of ${tr.userData.firstName}`"
                  >
                    <vs-avatar @click.native="openRemoveRelation(user, tr)" size="35px" class="-m-1 w-100 z-10"
                      v-if="user.userData.profilePictureUrl"
                      :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`" />
                    <vs-avatar @click.native="openRemoveRelation(user, tr)" v-else size="35px" class="-m-1" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      user.userData.firstName || 'boringAvatar',
                      user.userData.lastName || 'boringAvatar'
                    )}`" />
                  </vx-tooltip>
                </div>
              </span>

              <!-- UPDATED: Wrapped in Tooltip "Add Relationship" -->
              <vs-tooltip text="Add Relationship">
                <div @click="
                  addRelationPrompt = true;
                  relationForUser = tr;
                ">
                  <vs-avatar 
                      class="-m-2 z-10 relative cursor-pointer font-bold" 
                      size="40px" 
                      color="#10b981" 
                      text-color="white" 
                      icon-pack="feather" 
                      icon="icon-plus"
                  />
                </div>
              </vs-tooltip>
            </vs-td>

            <!-- Cell 5: ACTION -->
            <vs-td>
              <div class="flex items-center gap-2 justify-center">
                <preview-resume :email="tr.userData.email" />
                <talent-card-preview 
                  :userId="tr.userId" 
                  :email="tr.userData.email" 
                />
                <deactivate-user :firstName="tr.userData.firstName" :employeeId="tr._id" />
              </div>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- Add relationship popup -->
    <vs-popup 
      class="relationship-popup" 
      :active.sync="addRelationPrompt" 
      :button-close-hidden="true"
    >
      <div class="p-2">
        <!-- CUSTOM HEADER -->
        <div class="flex justify-between items-center pb-3 mb-4 border-b border-gray-200">
          <h4 class="font-bold text-xl text-gray-800 m-0">Add Relationship</h4>
          <div 
            class="cursor-pointer hover:bg-gray-100 rounded-full p-1 transition-transform duration-300 hover:rotate-90 flex items-center justify-center" 
            @click="addRelationPrompt = false; selectedUser = '';"
          >
            <vs-icon icon="close" size="20px" color="#000000"></vs-icon>
          </div>
        </div>

        <!-- Member Search Section -->
        <label class="text-sm text-gray-600 mb-1 block font-semibold">{{ $t('orgDashboard.talentPool.member') }}</label>
        
        <main class="dropdown w-full mb-4" v-click-outside="toggleListVisibility">
          <vs-input 
            size="large" 
            class="dropdown__search w-full" 
            v-model="selectedUser" 
            v-on:input="searchOrgUser()"
            @focus="toggleListVisibility(true)" 
            :state="errors.length > 0 ? false : null" 
            :placeholder="$t('orgDashboard.talentPool.searchUser')" 
          />
          
          <div class="dropdown__icons mt-2">
            <img v-if="listVisible" @click="toggleListVisibility(!listVisible)"
              class="cursor-pointer transform rotate-180" src="@/assets/images/icons/arrow-drop.svg" alt="" />
            <img v-else class="cursor-pointer" @click="toggleListVisibility(!listVisible)"
              src="@/assets/images/icons/arrow-drop.svg" alt="" />
          </div>

          <!-- Dropdown Results -->
          <vue-perfect-scrollbar v-if="searchedOrgUserArray.length > 0" class="dropdown__content"
            :class="listVisible ? 'block' : 'hidden'">
            <ul class="p-0 my-50">
              <li :class="selectedUser === user.userData.firstName + user.userData.lastName ? 'option__selected' : ''" 
                @click="selectUser(user)" class="flex items-center" v-for="user in searchedOrgUserArray" :key="user._id">
                <vs-avatar size="30px" class="mr-2" v-if="user.userData.profilePictureUrl"
                  :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`" />
                <vs-avatar size="30px" class="mr-2" v-else :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  user.userData.firstName, user.userData.lastName)}`" />
                <div class="flex flex-col">
                  <span class="user-name text-left text-sm">
                    {{ user.userData.firstName }} {{ user.userData.lastName }}
                  </span>
                  <span class="text-xs text-gray-500">
                    {{ user.userData.email }}
                  </span>
                </div>
              </li>
            </ul>
          </vue-perfect-scrollbar>

          <!-- No Results -->
          <vue-perfect-scrollbar v-if="searchedOrgUserArray.length === 0" class="dropdown__content h-10"
            :class="listVisible ? 'block' : 'hidden'">
            <ul class="p-0 my-2">
              <div class="flex justify-center user-name px-2 text-sm text-gray-500">
                {{ $t('orgDashboard.talentPool.userNotFound') }}
              </div>
            </ul>
          </vue-perfect-scrollbar>
        </main>

        <!-- Relationship Select Section -->
        <label class="text-sm text-gray-600 mb-1 block font-semibold">{{ $t('orgDashboard.talentPool.relationship') }}</label>
        
        <!-- UPDATED: Removed :append-to-body="true" to fix positioning issues -->
        <v-select 
          class="w-full mb-4" 
          v-model="relationShipData.relation" 
          :options="orgRelationShip" 
          label="label"
        />

        <!-- Summary Text -->
        <div v-if="relationShipData && relationShipData.relation"
          class="text-sm font-medium text-gray-700 mt-2 mb-4 capitalize p-2 bg-gray-100 rounded">
          {{ selectedUser }} <span class="mx-1 font-normal">is</span>
          {{ relationShipData.relation.label }} <span class="mx-1 font-normal">of</span>
          {{ relationForUser.userData.firstName }}
          {{ relationForUser && relationForUser.userData && relationForUser.userData.lastName ? relationForUser.userData.lastName : "" }}
        </div>

        <!-- FOOTER -->
        <div class="flex justify-end mt-6 pt-2">
          <vs-button 
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
            class="font-semibold px-8" 
            :class="relationShipData && relationShipData.selectedUser && relationShipData.relation ? '' : 'opacity-50 pointer-events-none'"
            @click.native="saveRelation"
          >
            {{ $t('orgDashboard.talentPool.save') }}
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Remove relationship popup  -->
    <vs-prompt title="" @close="removeRelationPrompt = false" :active="removeRelationPrompt" buttons-hidden>
      <vs-col class="pb-4" v-if="userRelationshipData && userRelationshipData.from">
        <vs-row class="text-xl font-semibold text-black border-4">{{ $t('orgDashboard.talentPool.relationship') }}</vs-row>
        <div class="text-gray-700 text-xl" :class="userRelationshipData.from.relationship.label === 'Others'
            ? 'hidden'
            : ''
          ">
          {{ userRelationshipData.from.userData.firstName }}
          is {{ userRelationshipData.from.relationship.label }} of
          {{ userRelationshipData.by.userData.firstName }}
        </div>

        <vs-row class="items-center justify-between mt-2 rounded-lg border-user px-4 py-2">
          <vs-row class="w-auto items-center">
            <div>
              <vs-avatar @click.native="profileCard = true" v-if="userRelationshipData.from.userData.profilePictureUrl"
                size="45px" class="-m-1 mr-2" :src="constants.s3Bucket +
                  '/editor/profile-pictures/' +
                  userRelationshipData.from.userData.profilePictureUrl
                  " />
              <vs-avatar @click.native="profileCard = true" v-else size="45px" class="-m-1 mr-2" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                userRelationshipData.from.userData.firstName ||
                'boringAvatar',
                userRelationshipData.from.userData.lastName || 'boringAvatar'
              )}`" />
            </div>
            <div>
              <div class="text-left text-lg font-semibold text-black">
                {{ userRelationshipData.from.userData.firstName }}
                {{ userRelationshipData.from.userData.lastName }}
              </div>
              <div>
                {{ userRelationshipData.from.userData.email }}
              </div>
            </div>
          </vs-row>

          <img @click="removeRelationship" class="w-8 h-8 cursor-pointer" src="@/assets/images/icons/remove-dash.svg"
            alt="Remove Relationship" />
        </vs-row>
      </vs-col>
    </vs-prompt>
    <ResumeUploadModal 
      v-if="showResumeUploadModal" 
      :organization-id="orgData._id" 
      @close="showResumeUploadModal = false"
      @upload-complete="refreshUserList" 
    />

    <vs-popup class="profile-card" v-if="userRelationshipData && userRelationshipData.by && profileCard"
      :title="userRelationshipData.from.userData.firstName + `'s Profile Card`" :active.sync="profileCard"
      :button-close-hidden="true">
      <profile-card-popup :selectedUserData="userRelationshipData.from" />
    </vs-popup>

    <vs-prompt :active="importDataPrompt" @close="importDataPrompt = false" title="Import From Excel" buttons-hidden>
        <div></div>
        <label>

        </label>
    </vs-prompt>
    <vs-popup class="profile-card" v-if="isEmpAddRequest"
      :title="$t('orgDashboard.talentPool.addNewEmployee')" :active.sync="isEmpAddRequest"
      :button-close-hidden="true">
      <add-employee-card 
        :roles="roles" 
        @close="isEmpAddRequest = false" 
      />
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import constants from "@/constants";
import DeactivateUser from "./components/DeactivateUser.vue";
import vSelect from "vue-select";
import ProfileCardPopup from "./components/ProfileCardPopup.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import debounce from "debounce";
import AddEmployeeCard from "./components/AddEmployeeCardPopup.vue";
import ResumeUploadModal from './components/ResumeUploadModal.vue';
import ResumeUploadProgress from './components/ResumeUploadProgress.vue';
import PreviewResume from './components/PreviewResume.vue';
import TalentCardPreview from './components/TalentCardPreview.vue';

const API_BASE_URL = process.env.VUE_APP_API_URL;

export default {
  components: {
    DeactivateUser,
    vSelect,
    ProfileCardPopup,
    VuePerfectScrollbar,
    AddEmployeeCard,
    ResumeUploadModal,
    ResumeUploadProgress,
    PreviewResume,
    TalentCardPreview,
  },
  data() {
    return {
      constants,
      selected: [],
      itemsPerPage: 50,
      isMounted: false,
      isEmpAddRequest: false,
      addNewDataSidebar: false,
      sidebarData: {},
      deactivationInProgress: {},
      reviewUserRequest: [],
      isRequestLoading: false,
      searchedUserArray: [],
      searchValue: "",
      orgColor: "",
      addRelationPrompt: false,
      removeRelationPrompt: false,
      userRelationshipData: {},
      orgEmployees: [],
      relationShipData: {},
      orgRelationShip: [],
      relationForUser: {},
      profileCard: false,
      listVisible: false,
      filteredUsers: [],
      selectedUser: "",
      searchedOrgUserArray: [],
      search: "",
      importDataPrompt: false,
      showResumeUploadModal: false,
      pollingInterval: null,
      uploadFinished: false,
      isDragging: false, // New state for drag overlay
      uploadFinished: false,
    };
  },
  computed: {
    ...mapState('organization', [
        'activeResumeBatchId',
        'resumeBatchStatus'
    ]),
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    products() {
      return this.$store.state.dataList.products;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    employeesData() {
      return this.$store.state.organization.employees;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    userData() {
      return this.$store.state.users.data;
    },
    roles(){
        return this.$store.state.organization.organizationConfiguration.roleTitle.values
    }
  },
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  watch: {
    activeResumeBatchId(newId) {
        if (newId) {
            this.startPolling(newId);
        } else {
            this.stopPolling();
        }
    },
    
    // This watcher handles the result of the polling.
    resumeBatchStatus(newStatus) {
        if (!newStatus) return;

        const isFinished = ['completed', 'completed_with_errors', 'failed'].includes(newStatus.status);

        if (isFinished) {
            this.stopPolling();
            
            if (!newStatus.wasAlreadyFinished) {
              if (newStatus.status.startsWith('completed')) {
                  // 1. Mark as finished to update UI text to "Done!"
                  this.uploadFinished = true; 
                  
                  this.$vs.notify({ title: 'Processing Complete', text: 'Resumes have been processed.', color: 'success' });
                  this.refreshUserList();

                  // 2. Wait 3 seconds, then reset everything
                  setTimeout(() => {
                      this.clearBatch();      // Removes progress bar
                      this.uploadFinished = false; // Reverts text to "No Pending Request"
                  }, 3000); 

              } else {
                  this.$vs.notify({ title: 'Processing Failed', text: 'There was an error processing the resumes.', color: 'danger' });
                  this.clearBatch();
              }
            }
        }
    },
    orgData() {
      if (this.orgData && this.orgData._id) {
        this.$store.dispatch("organization/fetchAllEmployees", {
          organizationId: this.orgData._id,
        });
        this.orgColor = this.orgData.primaryThemeColor;

        this.getEmployeeRequest(this.orgData._id);
      }
    },
    searchValue(newVal) {
      if (newVal === "") {
        this.searchedUserArray = this.reviewUserRequest;
      }
    },
    addRelationPrompt(newVal) {
      if (newVal) {
        this.relationShipData = {};
        this.fetchOrgEmployees(this.orgData._id);
        this.getOrgRelation(this.orgData._id);
      }
    },
  },
  methods: {
    debounceInput: debounce(function (e) {
      this.$store.commit("community/SET_SEARCH_TEXT", e.target.value);
    }, 500),

    generateCustomLabel(item) {
      console.log(item);
      return "userData.firstName";
    },
    getFlag(countryCode) {
      if (countryCode)
        return `https://countryflagsapi.com/png/${countryCode.toLowerCase()}`;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getOrderStatusColor(status) {
      if (status === "on_hold") return "warning";
      if (status === "delivered") return "success";
      if (status === "canceled") return "danger";
      return "primary";
    },
    getValidRelationships(relationships) {
      if (!relationships) return [];
      
      // Get keys of currently configured relationships
      const activeRelationKeys = this.$store.state.organization.organizationConfiguration?.relationship?.values?.map(r => r.key) || [];
      
      // Only return relationships whose type (key) still exists in the config
      return relationships.filter(rel => rel.relationship && activeRelationKeys.includes(rel.relationship.key));
    },

    getRelationName(relationObj) {
      if (relationObj && relationObj.key) {
        let orgRelations = this.$store.state.organization.organizationConfiguration?.relationship?.values || [];
        let relationItem = orgRelations.find(relation => relation.key === relationObj.key);

        // FIX: Return null instead of the key if the config doesn't exist anymore
        return relationItem ? relationItem.label : null;
      }
      return null;
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetchUserById(userId) {
      if (userId) {
        const userRecord = this.$store.dispatch("users/fetchUser", userId);
        return userRecord;
      }

      return {};
    },
    deactivateUser(employeeId) {
      this.deactivationInProgress[employeeId] = true;
      this.$forceUpdate();
    },
    getEmployeeRequest(orgId) {
      this.isRequestLoading = true;
      this.$store
        .dispatch("organization/getEmployeeRequest", orgId)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            this.reviewUserRequest = res.data;
            this.searchedUserArray = res.data;
          } else {
            this.reviewUserRequest = [];
          }
        })
        .catch(() => { })
        .finally(() => {
          this.isRequestLoading = false;
        });
    },
    fetchOrgEmployees(orgId) {
      if (this.orgEmployees.length === 0) {
        this.$store
          .dispatch("organization/getAllOrgEmployees", orgId)
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              const updatedObj = res.data.map((item) => ({
                ...item,
                fullName: `${item.userData.firstName} ${item && item.userData && item.userData.lastName
                    ? item.userData.lastName
                    : ""
                  }`,
              }));

              this.orgEmployees = updatedObj;
              this.searchedOrgUserArray = this.orgEmployees;
            }
          })
          .catch(() => { });
      }
    },
    searchUser() {
      if (this.searchValue) {
        this.searchedUserArray = this.reviewUserRequest.filter((user) => {
          if (user.data.firstName && user.data.lastName) {
            return (
              user.data.firstName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              user.data.lastName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else if (user.data.firstName) {
            return user.data.firstName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          } else if (user.data.lastName) {
            return user.data.lastName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedUserArray = this.orgBoardUsersArray);
      }
    },
    searchOrgUser() {
      if (this.selectedUser) {
        this.searchedOrgUserArray = this.orgEmployees.filter((user) => {
          if (user.userData.firstName && user.userData.lastName) {
            return (
              user.userData.firstName
                .toLowerCase()
                .includes(this.selectedUser.toLowerCase()) ||
              user.userData.lastName
                .toLowerCase()
                .includes(this.selectedUser.toLowerCase())
            );
          } else if (user.userData.firstName) {
            return user.userData.firstName
              .toLowerCase()
              .includes(this.selectedUser.toLowerCase());
          } else if (user.userData.lastName) {
            return user.userData.lastName
              .toLowerCase()
              .includes(this.selectedUser.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedOrgUserArray = this.orgEmployees);
      }
    },
    getOrgRelation(orgId) {
      this.$store
        .dispatch("organization/fetchOrganizationConfig", {
          organizationId: orgId,
        })
        .then((res) => {
          if (res && res.relationship) {
            // FIX: Filter out "Add Configuration" if it comes from the API
            this.orgRelationShip = res.relationship.values.filter(
              (item) => item.label !== "Add Configuration"
            );
          }
        })
        .catch(() => {
          this.orgRelationShip = [];
        });
    },
    selectUser(user) {
      this.selectedUser =
        user.userData.firstName + " " + user.userData.lastName;
      this.relationShipData.selectedUser = user;
      this.listVisible = false;
    },
    saveRelation() {
      const payload = {
        userIdFrom: this.relationForUser.userId,
        userIdTo: this.relationShipData.selectedUser.userId,
        assignedByUserId: this.userData._id,
        relationship: this.relationShipData.relation,
        organizationId: this.orgData._id,
      };
      this.$store
        .dispatch("organization/saveEmployeeRelation", payload)
        .then((res) => {
          if (res.message === "Relationship Saved Successfully") {
            this.relationForUser.employeeRelationshipsData.push({
              ...payload,
              userData: this.relationShipData.selectedUser.userData,
            });
            this.$vs.notify({
              color: "success",
              text: "Relationship added successfully",
            });

            this.$forceUpdate();
          }
        })
        .catch(() => {
          // console.log(err);
        })
        .finally(() => {
          this.addRelationPrompt = false;
        });
    },
    openRemoveRelation(user, tr) {
      this.userRelationshipData.from = user;
      this.userRelationshipData.by = tr;
      this.removeRelationPrompt = true;
    },
    removeRelationship() {
      const payload = {
        userIdFrom: this.userRelationshipData.from.userIdFrom,
        userIdTo: this.userRelationshipData.from.userIdTo,
        relationship: this.userRelationshipData.from.relationship,
        organizationId: this.orgData._id,
      };

      this.$store
        .dispatch("organization/removeEmployeeRelationship", payload)
        .then((res) => {
          if (res.status === "SUCCESS") {
            for (let i = 0; i < this.employeesData.length; i++) {
              if (
                this.employeesData[i].userId ===
                this.userRelationshipData.by.userId
              ) {
                for (
                  let j = 0;
                  j < this.employeesData[i].employeeRelationshipsData.length;
                  j++
                ) {
                  if (
                    this.employeesData[i].employeeRelationshipsData[j]._id ===
                    this.userRelationshipData.from._id
                  ) {
                    this.employeesData[i].employeeRelationshipsData.splice(
                      j,
                      1
                    );
                  }
                }
              }
            }
            this.removeRelationPrompt = false;
            this.userRelationshipData = {};
            this.$vs.notify({
              color: "success",
              text: "Relationship removed successfully",
            });
            this.$forceUpdate();
          }
        })
        .catch(() => { });
    },
    toggleListVisibility(value) {
      this.listVisible = value;
      if (value === false) {
        this.selectedUser = "";
      }
    },
    getRelationName(relationObj) {
      if (relationObj && relationObj.key) {
        // 1. Safely access the configuration array
        let orgRelations =
          this.$store.state.organization.organizationConfiguration?.relationship?.values || [];

        // 2. Try to find the matching relationship
        let relationItem = orgRelations.find(
          (relation) => relation.key === relationObj.key
        );

        // 3. Return the label if found, otherwise fallback to the key to prevent crash
        return relationItem ? relationItem.label : relationObj.key;
      }
      return "";
    },
    startPolling(batchId) {
        this.stopPolling();
        const poll = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/status/${batchId}`);
                if (!response.ok) { 
                    if (response.status !== 404) throw new Error(`Status check failed: ${response.status}`);
                    return; 
                }
                const data = await response.json();
                this.$store.dispatch('organization/updateResumeBatchStatus', data);

            } catch (error) {
                console.error("Polling error:", error);
                this.$vs.notify({ title: 'Status Update Failed', text: 'Could not retrieve progress updates.', color: 'danger' });
                this.stopPolling();
            }
        };
        poll(); // Poll immediately
        this.pollingInterval = setInterval(poll, 3000);
    },

    stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    },

    clearBatch() {
        this.$store.dispatch('organization/clearResumeBatch');
    },
    refreshUserList() {
      console.log('Upload complete, refreshing user list...');
        if (this.orgData && this.orgData._id) {
          this.$store.dispatch("organization/fetchAllEmployees", {
            organizationId: this.orgData._id,
          });
        }
    },
    handleUserUpload() {
      console.log(this.importDataPrompt);
      this.importDataPrompt = true;
      // const file = event.target.files[0];
      // if (!file) return;

      // const formData = new FormData();
      // formData.append('employeeData', file); // 'file' is the key expected by your backend
      // formData.append('orgId', this.orgData._id);    
      // this.$store.dispatch("organization/uploadUsersFromExcel",formData)
      // .then((res)=>{
      //   console.log("your response is",res);
      // })
      // .catch((error)=>{
      //     console.error('Upload failed:', error);
      // })
    },
    updateRoleAccess(value, id){
      // Robustness check: Ensure we have a valid ID and Value before calling API
      if (!id || !value) {
        console.warn("Attempted to update role with missing ID or Value");
        return;
      }

      const payload = {
        accessLevel : value,
        employeeId : id,
      }
      
      this.$store.dispatch("organization/patchEmployee", payload)
      .then(res => {
        if(res && !_.isEmpty(res)){
          if(res.status==="SUCCESS"){
            this.$vs.notify({
                title: 'Update Employee', 
                text: res.message,
                color: '#008000' // Success Green
            })
          }
        }
      })
      .catch(err => {
        console.log("your patch emp error is", err);
        this.$vs.notify({
            title: 'Error', 
            text: 'Failed to update role',
            color: 'danger'
        })
      });
    },
  onDragOver(e) {
      this.isDragging = true;
    },
    
    onDragLeave(e) {
      // Prevent flickering when dragging over child elements
      if (e.currentTarget.contains(e.relatedTarget)) return;
      this.isDragging = false;
    },

    onDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      
      if (!files || files.length === 0) return;

      // Client-side validation for file count (matches Python API constraint)
      if (files.length > 10) {
        this.$vs.notify({
          title: "Too many files",
          text: "Please upload between 1 and 10 resumes at a time.",
          color: "danger",
        });
        return;
      }

      this.uploadFilesBatch(files);
    },
    async uploadFilesBatch(fileList) {
      const formData = new FormData();
      
      // Append required form fields
      formData.append("api_token", localStorage.getItem("accessToken")); // Adjust key if token is stored differently
      formData.append("organization_id", this.orgData._id);
      formData.append("upload_type", "applicant");

      // Append files
      Array.from(fileList).forEach((file) => {
        formData.append("files", file);
      });

      try {
        // Show loading/processing state immediately if desired, 
        // though the batch ID response will trigger the main UI loader
        
        const response = await fetch(`${process.env.VUE_APP_API_URL}/upload-resumes-batch/`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (!response.ok) {
           throw new Error(result.detail || "Upload failed");
        }

        // Success: Update UI and Store
        this.$vs.notify({
          title: "Import Successful",
          text: "Resumes successfully imported. Processing now...",
          color: "success",
        });

        // Dispatching this ID triggers the watcher in your existing code,
        // which starts polling and shows the 'Processing Resumes...' text/progress bar.
        this.$store.dispatch('organization/startResumeBatch', result.batch_id);
        
        // Open the modal if you want to see detailed progress immediately
        // this.showResumeUploadModal = true; 

      } catch (error) {
        console.error("Batch upload error:", error);
        this.$vs.notify({
          title: "Upload Failed",
          text: error.message || "There was an error uploading the resumes.",
          color: "danger",
        });
      }
    },
  },
  async mounted() {
    this.isMounted = true;
    
    const existingBatchId = localStorage.getItem('activeResumeBatchId');

    if (existingBatchId) {
        // A batch exists. We must check its status IMMEDIATELY.
        try {
            const response = await fetch(`${API_BASE_URL}/status/${existingBatchId}`);
            if (response.ok) {
                const data = await response.json();
                const isFinished = ['completed', 'completed_with_errors', 'failed'].includes(data.status);

                if (isFinished) {
                    // This job is already done. Clear it right away and don't show the user.
                    console.log("Found a completed job on page load. Cleaning it up.");
                    this.clearBatch(); 
                } else {
                    // The job is still in progress. Load it into the store to start polling.
                    this.$store.dispatch('organization/startResumeBatch', existingBatchId);
                }
            } else {
                // The batch ID is invalid or expired on the server. Clean it up.
                console.log("Found an invalid batch ID on page load. Cleaning it up.");
                this.clearBatch();
            }
        } catch (error) {
            console.error("Error checking existing batch status:", error);
            this.clearBatch(); // Clean up on error to be safe.
        }
    }

    // Load main page data
    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("organization/fetchAllEmployees", {
        organizationId: this.orgData._id,
      });
      this.getEmployeeRequest(this.orgData._id);
      this.getOrgRelation(this.orgData._id);
    }
  },
  beforeDestroy() {
      this.stopPolling();
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

  .hide-thead {
    .vs-table--thead {
      display: none;
    }
  }
}

.integrations-image {
  margin-left: 5px;
  margin-right: 5px;
  height: 20px;
  width: 20px;
}

.relation-btn {
  border-radius: 2em;
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: fit-content;

  &-active {
    background: rgba(var(--vs-primary, "#F2C244"), 1);
    border-width: 0;
  }
}

.users-container {
  background: #fff;
  box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  border-radius: 0.5rem;
  flex-wrap: wrap;

  h4 {
    color: #101828 !important;
    font-weight: 600;
  }

  .arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    // background-color: #fff;
    // border: 1px solid #98a2b3;
    color: #98a2b3;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .next {
    right: 1em;
  }
}

.dropdown {
  position: relative;
  display: inline-block;

  &__icons {
    padding: 0.75rem 0.75rem 0 0;
    position: absolute;
    right: 0;
    top: 0;

    img {
      width: 1.75rem;
      height: 1.75rem;
      background: #fff;
    }
  }

  &__content {
    width: 100%;
    height: auto;
    max-height: 200px;
    position: absolute;
    top: 100%;
    left: 0;
    overflow: hidden;
    z-index: 100;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

    ul {
      list-style-type: none;

      .option__selected {
        background: #989898;
        color: #fff;
      }

      li {
        padding: 0.3rem 0.75rem;
        cursor: pointer;

        .user-name {
          font-weight: 600;
        }

        &:hover {
          background: #989898;
          color: #fff;
        }
      }
    }
  }
}
</style>

<style scoped>
.input-border-circular {
  border-radius: 25px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: url("../../../assets/images/icons/search.svg") no-repeat scroll 7px 7px;
  background-size: 20px;
  background-position-y: 50%;
  background-position-x: 5%;
  padding-left: 50px;
  padding: 20px;
  width: 250px;
  height: 12px;
}

.vs-dropdown--item>>>.vs-dropdown--item-link {
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  padding-left: 1em;
  padding-right: 2em;
}

.con-vs-dropdown--menu {
  max-height: 20em;
  width: max-content;

  height: auto !important;
  overflow-y: scroll;
}

.con-vs-dropdown--menu::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.con-vs-dropdown--menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.378);
  /* border-radius: 10px; */
}

/* Handle */
.con-vs-dropdown--menu::-webkit-scrollbar-thumb {
  background: rgba(199, 195, 195, 0.658);
  border-radius: 10px;
}

.vs-input>>>.vs-input--icon {
  font-size: 1.5rem;
  color: #97a4bf !important;
}

.border-user {
  border: 2px solid #d0d5dd;
}

.vs-input>>>.vs-input--input {
  box-shadow: none;
}

.vs-input>>>.vs-input--placeholder {
  top: 5px;
}

.con-vs-avatar>>>.vs-avatar--text {
  font-size: 1.5rem;
}

.vx-card>>>.vx-card__body {
  padding: 0 !important;
}

.vs-con-table {
  background: rgb(255, 255, 255);
}

.vs-con-table>>>.vs-con-tbody {
  background: #fff;
  border: 2px solid #fff;
}

.vs-table--td>>>span {
  display: flex;
  align-items: center;
}

.vs-con-table>>>.vs-table--header {
  justify-content: space-between;
}

.vs-con-table>>>.vs-table--search {
  margin-left: 1rem;
}

.con-vs-dialog>>>.vs-dialog-text {
  padding-top: 0;
}

.profile-card .name {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: -0.02em;
  /* Licorice */
  color: #30384b;
}

.profile-card .role-title {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card .current-location,
.profile-card .email {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  /* identical to box height, or 93% */
  letter-spacing: 0.03em;
  text-transform: uppercase;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  /* or 144% */
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card>>>.vs-popup--header {
  display: none !important;
}

.profile-card>>>.vs-popup {
  width: 950px;
}

.con-vs-popup>>>.vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.relationship-popup {
  .vs-popup--header {
    display: none !important;
  }
  
  /* This allows the dropdown to hang outside the modal box */
  .vs-popup--content {
    padding: 0 !important;
    width: 100% !important;
    overflow: visible !important; 
  }
}
.data-list-container {
  min-height: 500px; /* Ensure there is height for the drop zone even if empty */
}

/* Updated Styles for Screenshot 2 View */
.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* Darker semi-transparent background */
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  backdrop-filter: blur(4px); /* Slight blur effect */
  animation: fadeIn 0.3s ease-in-out;
  pointer-events: none; /* Crucial: allows drop events to pass through to container */
}

.drag-content {
  text-align: center;
  color: white;
}

.drag-content i {
  font-size: 5rem; /* Larger icon */
  color: white;
  display: block;
  margin-bottom: 1rem;
}

.drag-text {
  color: white !important;
  font-size: 1.75rem;
  font-weight: 500;
  margin: 0;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(1.02); }
  to { opacity: 1; transform: scale(1); }
}
</style>